(ns common.schema.entities.graph-meta
  (:require [common.schema.schema-utils :as su]))

(def schema
  (concat
   ;;TODO :graph-meta/type needed? or everything based on containing
   ;;      graph-reference's type?
   (su/percentage-field
    :graph-meta/ownership-percentage
    "Ownership-%"
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/keyword-field
    :graph-meta/executive-role
    "Role"
    [{:value :executive-role/ceo
      :label "CEO"}
     {:value :executive-role/cfo
      :label "CFO"}
     {:value :executive-role/managing-director
      :label "Managing director"}
     {:value :executive-role/executive
      :label "Executive"}]
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/keyword-field
    :graph-meta/board-member-role
    "Role"
    [{:value :board-member/board-member
      :label "Board member"}
     {:value :board-member/chair
      :label "Chair"}]
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/keyword-field
    :graph-meta/auditor-role
    "Role"
    [{:value :auditor/lead-auditor
      :label "Lead auditor"}
     {:value :auditor/assisting-auditor
      :label "Assisting auditor"}]
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})))
